<p-table [value]="items()" size="small" [rowHover]="true" (onSort)="sort($event)" [lazy]="true" [sortField]="sorting().orderByClause" [sortOrder]="sorting().orderDirection === 'asc' ? 1 : -1">

    <ng-template pTemplate="header">
        <tr>
            <th pSortableColumn="order_code" >Commessa <p-sortIcon field="order_code" /></th>
            <th pSortableColumn="position_code">Posizione <p-sortIcon field="position_code" /></th>
            <th >Referente</th>
            <th pSortableColumn="position_quantity" style="max-width: 5rem;">Quantità <p-sortIcon field="position_quantity" /></th>
            <th pSortableColumn="position_expire_date" style="max-width: 5rem;">Scadenza <p-sortIcon field="position_expire_date" /></th>
            <th pSortableColumn="position_state_id" style="max-width: 3rem;">Stato <p-sortIcon field="position_state_id" /></th>
        </tr>
    </ng-template>

    <ng-template pTemplate="body" let-position>
        <tr (click)="onSelect.emit(position)" class="cursor-pointer">
            <td>
                <div><b>{{position.orderCode}}</b></div>
                <div>{{position.orderShortDescription}}</div>
            </td>
             <td>
                <div><b>{{position.positionCode}}</b></div>
                <div>{{position.positionShortDescription}}</div>
            </td>
            <td>
                <div>{{workflowState() ? (position[workflowState().referenceKey!] ?? 'Nessun referente') : position['productionReference'] ?? position['projectReference'] ?? position['preventiveReference'] ?? 'Nessun referente'}}</div>
            </td>
            <td >{{position.positionQuantity}}</td>
            <td >{{position.positionExpireDate | date:'dd-MM-yyyy'}}</td>
            <td><p-tag [severity]="getPositionStatusSeverity(position[workflowState().stateKey!])" [value]="getPositionStatusDescription(position[workflowState().stateKey!])"></p-tag></td>

        </tr>
    </ng-template>
</p-table>